import { BaseRange, Editor, Node, Path } from 'slate'

import { BLOCK_FORMATS } from './../interface/custom-types'

type ListNodeType = {
  isList: boolean
  listFormat?: BLOCK_FORMATS
  parentNode?: Node
  parentPath?: Path
}

export const listsNodeHelper = (editor: Editor, selection: BaseRange) => {
  const result: ListNodeType = { isList: false }

  const currentPath = Path.parent(selection.anchor.path)
  const currentNode = Node.get(editor, currentPath)
  if (currentNode) {
    const parrentPath = Path.parent(currentPath)
    const parrentNode = Node.get(editor, parrentPath)
    if (parrentNode && parrentNode['type'] === BLOCK_FORMATS.listItem) {
      const listNodePath = Path.parent(parrentPath)
      const listNode = Node.get(editor, listNodePath)

      result.isList = true
      result.listFormat = listNode['type']
      result.parentPath = parrentPath
      result.parentNode = parrentNode
    } else {
      result.parentPath = currentPath
      result.parentNode = currentNode
    }
  } else {
    result.parentPath = currentPath
    result.parentNode = currentNode
  }

  return result
}
